import React, {
    useState,
    useEffect
} from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
    makeStyles
} from '@material-ui/styles';
import {
    Grid, TableHead
} from '@material-ui/core';
import {
    classBody
} from '@babel/types';
import {
    Card,
    CardActions,
    CardHeader,
    CardContent,
    Button,
    Divider,
    Table,
    TableBody,
    TableRow,
    TextField,
    TableCell,
    colors
} from '@material-ui/core';
import ReactHtmlParser from 'react-html-parser';
import { get_booking_info } from '../../api/API';
import SaveIcon from '@material-ui/icons/Save';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3)
    },
    container: {
        marginTop: theme.spacing(3)
    },
    // pdTop: {
    //     paddingTop: '30px',
    // }
    leftIcon: {
        marginRight: theme.spacing.unit,
      },
}));

export default class Showroom_booking extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
           appointment: {
               name: "",
               pax: "",
               contact: ""
           }
        };
    }

    async get_data(){
        let data = await get_booking_info(this.props.appointment_id);

        if(data){
            this.setState({
                ...this.state,
                appointment: data
            });
        }
    }

    componentDidMount(){
        this.get_data();
    }

    render() {
        return (
            <React.Fragment>
                <Card>
                    <CardHeader title="Booking Info">
                        <TextField />
                    </CardHeader>
                    <CardContent>
                        <Table>
                            <TableBody>
                                <TableRow>
                                    <TableCell>Agent</TableCell>
                                    <TableCell>{ this.state.appointment.name }</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Number of people</TableCell>
                                    <TableCell>{ this.state.appointment.pax }</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Contact</TableCell>
                                    <TableCell>{ this.state.appointment.contact }</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </CardContent>
                    <Divider />
                    <CardActions className={this.props.classes.flexend}>
                        <Button
                            className={this.props.classes.saveButton}
                            variant="contained"

                        >
                             <SaveIcon className={this.props.classes.leftIcon}/>
                            Save Changes
                         </Button>
                    </CardActions>

                </Card>
            </React.Fragment>
        )
    }

} 
